// 공고 관리 공통 상수. 스위치 key는 서버 job_opening 컬럼명과 같아야 함.
import totalLocationData from '../../../data/locationdata';

export const SWITCHES = [
    { key: "albamonPost", label: "알바몬 공고" },
    { key: "albamonAd", label: "알바몬 광고" },
    { key: "daangnPost", label: "당근 공고" },
    { key: "daangnAd", label: "당근 광고" },
];

// sunbae 지점 (value=영문 코드, label=한글)
export const sunbaeBranches = totalLocationData
    .filter((l) => l.academy.includes("sunbae") && l.english !== "total")
    .map((l) => ({ value: l.english, label: l.korean }));

// 표·기록 표시용: "센텀점" → "센텀", 모르는 코드는 그대로
export const branchLabel = (branchKey: string) => {
    const found = sunbaeBranches.find((b) => b.value === branchKey);
    if (!found) return branchKey;
    return found.label.endsWith("점") ? found.label.slice(0, -1) : found.label;
};
